'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";
import PropTypes from 'prop-types';

import Alert from "react-bootstrap/Alert";

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import SimpleState from '@uw-it-sis/lib-react/lib/SimpleState';

import noticesStore from './NoticesStore';

/**
 * This is a widget which display notices retrieved for the user
 */
class NoticesWidget extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.store = noticesStore;
    }

    buildDoneComponent = () => {
        let component;

        let filteredNotices = this.store.getNotices(this.props.category, this.props.quarter);

        if (filteredNotices.length) {
            let noticeItems = filteredNotices.map(function (notice, i) {
                let attributeItems = null;

                if (notice.attributes && this.props.showAttributes) {
                    attributeItems = Object.keys(notice.attributes).map(function (key, i) {
                        return <div key={i}><strong>{key}</strong>: {notice.attributes[key]}</div>;
                    });
                }

                let text = notice.text.replace(/<\/span>&nbsp;<span/g, '</span><span');

                let htmlText = document.createElement('div');
                htmlText.innerHTML = text;
                let links = htmlText.getElementsByTagName('a');
                for (let i = 0; i < links.length; i++) {
                    links[i].setAttribute('target', '_blank');
                }

                let icon = null;
                if ( this.props.icon ) {
                    const NoticeIcon = this.props.icon;
                    icon = <div className="me-3"><NoticeIcon className="fs-4" aria-hidden={true} /></div>
                }

                return (
                    <li id={'notice-' + i} key={i} className="d-flex align-items-start" data-category={notice.category ?? ""} data-type={notice.type ?? ""} data-myplan-category={notice.myplanCategory ?? ""}>
                        {icon}
                        <div>
                            <div className="notice-html" dangerouslySetInnerHTML={{__html: htmlText.outerHTML}}></div>
                            {attributeItems}
                        </div>
                    </li>
                );
            }.bind(this));

            component = <ol className="list-unstyled d-flex flex-column mb-0 gap-3">{noticeItems}</ol>;
        } else {
            component = <p className="mb-0">{this.props.emptyMessage}</p>;
        }

        let header = null;
        if (this.props.header) {
            header = <h3 className="sr-only">{this.props.header}</h3>;
        }

        if ( ! this.props.emptyMessage && filteredNotices.length === 0 ) {
            return null;
        } else {
            return (
                <div className={'notices ' + (this.props.className ? this.props.className : '')}>
                    {header}
                    {component}
                </div>
            );
        }
    }

    buildErrorComponent = () => {
        return (
            <Alert variant="danger">
                There was a problem retrieving notices.
            </Alert>
        )
    }

    render() {
        // if the user isn't authenticated, or isn't a student, return nothing
        if ( !appStore.isAuthenticated() || !appStore.isStudent() ) {
            return null;
        }

        return <SimpleState state={this.store.state} doneComponentBuilder={this.buildDoneComponent} name="NoticesWidget" errorComponentBuilder={this.buildErrorComponent}/>
    }
}

NoticesWidget.propTypes = {
    category: PropTypes.string,
    quarter: PropTypes.string,
    emptyMessage: PropTypes.string,
    showAttributes: PropTypes.bool,
    className: PropTypes.string,
    header: PropTypes.string,
    icon: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func
    ])
};

export default observer(NoticesWidget);
